<!--suppress JSUnresolvedVariable -->
<template>
  <div class="parental-guardianship">
    <div
      class="top jumbotron jumbotron-fluid mb-2"
      :style="{ backgroundImage: 'url(' + backgroundUrl + ')' }"
    >
      <div class="container text-success">
        <h1 class="animated fadeInDown">家长监护</h1>
        <p class="animated fadeInDown">—— {{ sectionSubTitle }} ——</p>
      </div>
    </div>
    <div class="container my-5">
      <!-- 面包屑导航 -->
      <div class=" text-right position mb-3 d-none d-md-block text-muted">
        当前位置：
        <router-link to="/toHome" class="text-muted">首页</router-link>
        /
        <a href="#" class="text-muted">家长监护</a>
      </div>
      <div v-html="article.articleContent"></div>

      <el-link
        type="success"
        class="font-weight-bold"
        href="http://wingjoy.cn/attachment/%E5%AE%B6%E9%95%BF%E7%9B%91%E6%8A%A4%E5%B7%A5%E7%A8%8B%E6%96%87%E6%A1%A3.rar#"
      >
        <i class="fa fa-file-word-o" aria-hidden="true"></i>
        家长监护工程文档下载
      </el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "ParentalGuardianship",
  data() {
    return {
      sectionSubTitle: "",
      backgroundUrl: "",
      article: {}
    };
  },
  mounted() {
    this.getNavById();
    this.getArticleById();
  },
  methods: {
    getNavById() {
      this.axios
        .get("/navigation/getNavById/" + 6)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.backgroundUrl = resp.data.data.bannerImg;
            this.sectionSubTitle = resp.data.data.subTitle;
          }
        })
        .catch();
    },
    getArticleById() {
      this.axios
        .get("/article/getArticleById/" + 1)
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.article = resp.data.data;
          }
        })
        .catch();
    }
  }
};
</script>

<style lang="scss">
.parental-guardianship {
  margin-top: 67px;

  .top {
    background: no-repeat center;
    width: 100%;
    background-size: cover;
  }
}
</style>
